/** Static hero assets (1024×576). Supply a ≥2560px-wide master for sharp full-bleed on large viewports. */
export const CC_ANTIQUE_HERO_WIDTH = 1024;
export const CC_ANTIQUE_HERO_HEIGHT = 576;

export const CC_ANTIQUE_HERO_IMAGE_AVIF =
  "/assets/imgs/closing-optimized/antique-1024.avif";
export const CC_ANTIQUE_HERO_IMAGE_WEBP =
  "/assets/imgs/closing-optimized/antique-1024.webp";
export const CC_ANTIQUE_HERO_IMAGE_JPG =
  "/assets/imgs/contact/antique-hero.jpg";

/** @deprecated Use `CcAntiqueHeroPicture` or WebP/AVIF paths above. */
export const CC_ANTIQUE_HERO_IMAGE = CC_ANTIQUE_HERO_IMAGE_JPG;

type CcAntiqueHeroPictureProps = {
  className?: string;
  imgClassName?: string;
  fetchPriority?: "high" | "low" | "auto";
  /**
   * At 1024px wide, AVIF can look softer than WebP on some displays; contact uses WebP first.
   * Footer/closing band keeps AVIF-first for smaller transfer when assets are higher-res.
   */
  sourceOrder?: "avif-first" | "webp-first";
};

export function CcAntiqueHeroPicture({
  className,
  imgClassName,
  fetchPriority = "low",
  sourceOrder = "avif-first",
}: CcAntiqueHeroPictureProps) {
  const avifSource = (
    <source srcSet={CC_ANTIQUE_HERO_IMAGE_AVIF} type="image/avif" />
  );
  const webpSource = (
    <source srcSet={CC_ANTIQUE_HERO_IMAGE_WEBP} type="image/webp" />
  );

  return (
    <picture className={className}>
      {sourceOrder === "webp-first" ? (
        <>
          {webpSource}
          {avifSource}
        </>
      ) : (
        <>
          {avifSource}
          {webpSource}
        </>
      )}
      <img
        className={imgClassName}
        src={CC_ANTIQUE_HERO_IMAGE_JPG}
        alt=""
        width={CC_ANTIQUE_HERO_WIDTH}
        height={CC_ANTIQUE_HERO_HEIGHT}
        decoding="async"
        fetchPriority={fetchPriority}
      />
    </picture>
  );
}
